import { Component } from "react";
import Slide from "./slide/slide";
class LandingPage extends Component {
    render() {
        return (
            <section>
                {/* <div class="container"> */}
                <Slide device={this.props.device} />
                {/* </div> */}
            </section>
        )
    }
}

export default LandingPage;